import { DataGrid } from '@tableau/data-grid-1-wrapper';

import { SparseCachedList } from '~commonInfra/components/SparseCachedList';

import { ISliceable } from '../../../httpClient/fetchers/ISliceable';

export function getReactDataGridRowStore<T>(sliceable: ISliceable<any>) {

  const keyForItem = ((item: T) => (<any>item)['id']);

  const sparseList = new SparseCachedList(
    sliceable,
    (item: T): DataGrid.Row => {
      return {
        key: keyForItem(item),
        data: item as any,
        // TODO: 769624 - Replace rowStyle with specifically styled cell formatters when we upgrade to Data Grid 2.0
        rowStyle: null
      };
    });

  // map the Q API to a generic callback
  return {
    getItems: (start: number, end: number, rowHandler: (rows: DataGrid.Row[]) => void) => {
      sparseList.getItems(start, end).then(rowHandler);
    }
  };
}